<template>
    <div class="home">
        <div style="width: 100%; height: 25vh;" id="main" ref="main"></div>
    </div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: "chartc",
    data() {
        return {

        };
    },
    mounted() {
        // let myChart = echarts.init(this.$refs.main);
        // myChart.setOption(this.Circularchart);
        // console.log(this.Circularchart.series[0].data,"数据列表A")
        // console.log(this.dataVal,"数据列表B")

        this.$nextTick(() => {
            this.fetchData()
        })
    },
    methods: {
        fetchData() {
            console.log("执行这里")
            var that = this
            that.axios.post(this.$url.baseUrl + 'index/userlist', {
            })
                .then(function (res) {
                    console.log(res.data)
                    // var chartDom = document.getElementById('main');
                    // var myChart = echarts.init(chartDom);
                    var myChart = echarts.init(that.$refs.main);
                    var option;

                    option = {
                        tooltip: {
                            trigger: "item",
                            formatter: "{b}: {c} ({d}%)",
                        },
                        // legend用数组两项，分两排显示
                        legend: [
                            {
                                top: '15%',
                                orient: "vertical",
                                // 图例变圆
                                icon: "circle",
                                itemWidth: 10,
                                itemHeight: 10,
                                textStyle: {
                                    fontSize: 12,
                                    color: '#FFFFFF',
                                    rich: {
                                        name: {
                                            color: '#A9FDFF'
                                        },
                                        val: {
                                            color: '#ffffff'
                                        }
                                    }
                                },
                                // 调整第一排图例位置
                                right: 0,
                                x: "78%",
                                data: res.data.data.jl,
                            },
                            {
                                itemWidth: 10,
                                itemHeight: 10,
                                orient: "vertical",
                                icon: "circle",
                                top: '15%',
                                // 调整第二排图例位置
                                right: 0,
                                x: "58%",
                                textStyle: {
                                    fontSize: 12,
                                    color: '#FFFFFF'
                                },
                                data: res.data.data.ol,
                            },
                        ],
                        label: {
                            fontSize: 12,
                            show: true,
                            position: "inner",
                            // formatter: "{b}:{c}" + "\n\r" + "({d}%)",
                            // 每一块的数据显示格式
                            formatter: "{c}",
                        },
                        graphic: [  //为环形图中间添加文字
                            {
                                type: "text",
                                left: '23%',
                                top: '50%',
                                style: {
                                    text: "各企业使用" + "\n\r" + "\n\r" + "用户占比",
                                    textAlign: "center",
                                    fill: "#FFFFFF",
                                    fontSize: 10,
                                    lineHeight: 15,
                                },
                            },
                        ],
                        series: [
                            {
                                name: "",
                                type: "pie",
                                center: ['30%', '55%'],
                                radius: ["30%", "50%"],
                                avoidLabelOverlap: true,
                                data: res.data.data.st,
                                labelLine: {
                                    show: true,           // 显示标线
                                    length: 10,           // 第一个标线段的长度
                                    length2: 15,          // 第二个标线段的长度
                                    smooth: false          // 是否启用标线的平滑曲线
                                },
                            },
                        ],
                        color: res.data.data.cl,
                    }

                    option && myChart.setOption(option);

                    // 窗口改变 重新调用绘制地图
                    window.addEventListener('resize', () => {
                        if (myChart && myChart.resize) {
                            myChart.resize()
                        }
                    })

                    // 动态显示tooptip，每隔3秒去提示
                    var faultByHourIndex = 0 //播放所在下标
                    var faultByHourTime = setInterval(function () {
                        //使得tootip每隔三秒自动显示
                        myChart.dispatchAction({
                            type: 'showTip', // 根据 tooltip 的配置项显示提示框。
                            seriesIndex: 0,
                            dataIndex: faultByHourIndex
                        })
                        faultByHourIndex++
                        // faultRateOption.series[0].data.length 是已报名纵坐标数据的长度
                        if (faultByHourIndex > res.data.data.jl.length) {
                            faultByHourIndex = 0
                        }
                    }, 3000)
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Chartc.vue